import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { stringSorter } from "../../utils/functions.js";
import DataTable from "../../components/CustomDatatable/index.js";
import {
  Button,
  Card,
  Space,
  Typography,
  Breadcrumb,
  Row,
  Col,
  Modal,
  message,
} from "antd";
import {
  EditOutlined,
  HomeOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { Spinner } from "reactstrap";
import PackageTransactionForm from "./PackageTransactionForm.js";
import { enhanceColumnsWithFilters } from "../../components/ColumnFilters/index.js";
import moment from "moment-timezone";
import {
  addPackageTransaction,
  deletePackageTransaction,
  getPackageTransaction,
  updatePackageTransaction,
} from "../../store/actions/packageTransactions.js";
import { getCustomers } from "../../store/actions/customers";
import { getPackage } from "../../store/actions/package";
// import { getBusinessType } from "../../store/actions/businessType.js";

const { Title } = Typography;

const PackageTransaction = () => {
  document.title = "Packages Transaction";
  const [isLoading, setIsLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const dispatch = useDispatch();

  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const packageReducer = useSelector((state) => state.packageTransaction.list);
  const businessType = useSelector((state) => state.businessType.list);
  const customers = useSelector((state) => state.customers.list);
  const packages = useSelector((state) => state.packageReducer.list);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        await dispatch(getPackageTransaction());
        // await dispatch(getBusinessType());
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    };

    fetchProducts();
  }, [dispatch]);

  useEffect(() => {
    dispatch(getCustomers());
    dispatch(getPackage());
  }, [dispatch]);

  const handleCreate = async (values) => {
    if (selectedRecord) {
      const updateData = {
        id: selectedRecord.id,
        ...values,
      };
      await dispatch(updatePackageTransaction(updateData));
      await dispatch(getPackageTransaction());
    } else {
      await dispatch(addPackageTransaction({
        cusId: values.cusId,
        pId: values.pId,
        paymentMode: values.paymentMode,
        paymentRec: values.paymentRec,
        amount: values.amount
      }));
      await dispatch(getPackageTransaction());
    }
    setIsModalVisible(false);
  };

  const handleDelete = async (item) => {
    setItemToDelete(item);
    setDeleteModalVisible(true);
  };

  const confirmDelete = async () => {
    try {
      await dispatch(deletePackageTransaction(itemToDelete.id));
      await dispatch(getPackageTransaction());
      setDeleteModalVisible(false);
    } catch (error) {
      message.error("An error occurred while deleting the item");
    }
  };

  // const handleChangeStatus = async (id, currentStatus) => {
  //   const newStatus = currentStatus === 1 ? 0 : 1; // Toggle status
  //   const updatedData = { id: id, status: newStatus }; // Create an object for update
  //   await dispatch(updatePackageTransactionStatus(updatedData));
  //   await dispatch(getPackageTransaction());
  // };

  // const renderCell = (text) => (text ? text : "N/A");
  let columns = [
    {
      title: "Customer Name",
      dataIndex: "customerName",
      key: "customerName",
      sorter: stringSorter("customerName"),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Customer Mobile",
      dataIndex: "customerMobile",
      key: "customerMobile",
      sorter: stringSorter("customerMobile"),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Customer Email",
      dataIndex: "customerEmail",
      key: "customerEmail",
      sorter: stringSorter("customerEmail"),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Code",
      dataIndex: "customerDb",
      key: "customerDb",
      sorter: stringSorter("customerDb"),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      sorter: stringSorter("amount"),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
      render: (date) =>
        moment(date).isValid() ? moment(date).format("DD/MM/YYYY") : "",
      sorter: (a, b) =>
        moment(a.createdAt).isValid() && moment(b.createdAt).isValid()
          ? moment(a.createdAt).unix() - moment(b.createdAt).unix()
          : 0,
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
      render: (date) =>
        moment(date).isValid() ? moment(date).format("DD/MM/YYYY") : "",
      sorter: (a, b) =>
        moment(a.createdAt).isValid() && moment(b.createdAt).isValid()
          ? moment(a.createdAt).unix() - moment(b.createdAt).unix()
          : 0,
      sortDirections: ["ascend", "descend"],
    },
    // {
    //   title: "Created By",
    //   dataIndex: "createdByName",
    //   key: "createdByName",
    //   sorter: stringSorter("createdByName"),
    //   sortDirections: ["ascend", "descend"],
    //   render: renderCell,
    // },
    // {
    //   title: "Created At",
    //   dataIndex: "createdAt",
    //   key: "createdAt",
    //   render: (date) =>
    //     moment(date).isValid()
    //       ? moment(date).format("YYYY-MM-DD HH:mm:ss")
    //       : "",
    //   sorter: (a, b) =>
    //     moment(a.updatedAt).isValid() && moment(b.updatedAt).isValid()
    //       ? moment(a.updatedAt).unix() - moment(b.updatedAt).unix()
    //       : 0,
    //   sortDirections: ["ascend", "descend"],
    // },
    // {
    //   title: "Updated By",
    //   dataIndex: "updatedByName",
    //   key: "updatedByName",
    //   sorter: stringSorter("updatedByName"),
    //   sortDirections: ["ascend", "descend"],
    // },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",
    //   render: (text, record) => (
    //     <Switch
    //       checked={text === 1}
    //       onChange={() => handleChangeStatus(record.id, text)}
    //     />
    //   ),
    // },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="link"
            onClick={() => {
              setSelectedRecord(record);
              setIsModalVisible(true);
            }}
          >
            <EditOutlined />
          </Button>

          {/* <Button
            danger
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(record)}
          >
          </Button> */}
        </Space>
      ),
    },
  ];
  columns = enhanceColumnsWithFilters(columns);

  return (
    <div className="page-content">
      <Breadcrumb style={{ marginBottom: "16px" }}>
        <Breadcrumb.Item href="/">
          <HomeOutlined />
        </Breadcrumb.Item>
       <Breadcrumb.Item href="/dashboard">Dashboard</Breadcrumb.Item>
        <Breadcrumb.Item>Package Transaction</Breadcrumb.Item>
      </Breadcrumb>

      <Card>
        <Space direction="vertical" size="middle" style={{ width: "100%" }}>
          <Row justify="space-between" align="middle">
            <Col>
              <Title level={2} style={{ margin: 0 }}>
                Manage Package Transaction
              </Title>
            </Col>
            <Col>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                  setSelectedRecord(null);
                  setIsModalVisible(true);
                }}
              >
                Add Package
              </Button>
            </Col>
          </Row>
          {isLoading ? (
            <div className="d-flex justify-content-center">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <DataTable
              dataSource={packageReducer.map((item) => ({
                ...item,
                key: item.id,
                status: item.status ? 1 : 0,
              }))}
              columns={columns}
              filterBy={[
                {
                  field: "cusId",
                  fieldType: "SELECT",
                  options: customers,
                  filter: "id",
                  label: "customer",
                },
                {
                  field: "pId",
                  fieldType: "SELECT",
                  options: packages,
                  filter: "id",
                  label: "packages",
                },
              ]}
              isActive={false}
            />
          )}
        </Space>
      </Card>
      <PackageTransactionForm
        visible={isModalVisible}
        onCreate={handleCreate}
        onCancel={() => setIsModalVisible(false)}
        record={selectedRecord}
        businessType={businessType}
      />
      <Modal
        title="Confirm Delete"
        zIndex={100000000}
        visible={deleteModalVisible}
        onCancel={() => setDeleteModalVisible(false)}
        footer={[
          <Button key="cancel" onClick={() => setDeleteModalVisible(false)}>
            Cancel
          </Button>,
          <Button key="delete" danger onClick={confirmDelete}>
            Delete
          </Button>,
        ]}
      >
        <p>Are you sure you want to delete this item?</p>
        {itemToDelete && (
          <p>
            <strong>Record Name:</strong> {itemToDelete.name}
          </p>
        )}
      </Modal>
    </div>
  );
};

export default PackageTransaction;
